import { useWallet } from "@sundae/wallet-react";
import React, { lazy, Suspense } from "react";
import LoadingComponent from "../../components/LoadingComponent";

import { HomeHero } from "./components/HomeHero";

const LazyPortfolio = lazy(() => import(/* webpackChunkName: "Portfolio" */ "./Portfolio"));

const Home: React.FC = () => {
  const {
    state: { wallet },
  } = useWallet();

  if (wallet?.mainAddress)
    return (
      <Suspense fallback={<LoadingComponent />}>
        <LazyPortfolio />
      </Suspense>
    );

  return <HomeHero />;
};

export default Home;
